import { parse } from 'query-string'
import Cookies from 'js-cookie'
import { parseDomain } from 'parse-domain'

import { AFFILIATION_ID_LIFE_TIME_IN_DAYS } from './consts.mjs'
import { getExpirationDate } from './functions'

const getDomain = () => {
  try {
    const parseResult = parseDomain(window.location.hostname)
    const mainDomain = `.${
      parseResult.domain
    }.${parseResult.topLevelDomains.join('.')}`

    return mainDomain
  } catch (error) {
    return window.location.hostname
  }
}

const setAffiliationCookie = (name, value) => {
  Cookies.set(
    name,
    `${value}#${getExpirationDate(AFFILIATION_ID_LIFE_TIME_IN_DAYS)}`,
    {
      expires: AFFILIATION_ID_LIFE_TIME_IN_DAYS,
      domain: getDomain(),
    },
  )
}

const setCJCookie = (parsed) => {
  Cookies.remove('ime', { domain: getDomain() })
  setAffiliationCookie('cjap', `${parsed.utm_content}#${parsed.utm_term}`)
}

const setImpactCookie = (parsed) => {
  Cookies.remove('cjap', { domain: getDomain() })
  setAffiliationCookie('ime', parsed.irclickid)
}

export const setAffiliation = () => {
  const parsed = parse(window.location.search)

  if (parsed?.irclickid) {
    setImpactCookie(parsed)
  }

  if (parsed?.utm_source?.toLowerCase() === 'cj') {
    setCJCookie(parsed)
  }
}
